import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartbeatLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/system/heartbeat_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.34291 2.00007C6.63801 2.00438 6.8952 2.20214 6.97513 2.48624L9.42393 11.1931L10.7091 7.766C10.8067 7.5058 11.0555 7.3334 11.3333 7.3334H13.3333C13.7015 7.3334 14 7.63187 14 8.00007C14 8.36827 13.7015 8.66673 13.3333 8.66673H11.7953L9.95753 13.5675C9.85633 13.8374 9.59313 14.0117 9.30513 13.9995C9.01713 13.9873 8.7696 13.7914 8.69153 13.5139L6.29969 5.00946L5.30299 8.19894C5.21601 8.47727 4.95826 8.66673 4.66667 8.66673H2.66667C2.29848 8.66673 2 8.36827 2 8.00007C2 7.63187 2.29848 7.3334 2.66667 7.3334H4.17654L5.69701 2.46789C5.78504 2.18619 6.04781 1.9959 6.34291 2.00007Z"
		})
	})
});
export default SvgHeartbeatLine;
